import React from "react";
import { useFunnel } from "../../../context/FunnelContext";
import { trackFBEvent } from "../../../utils/facebookPixel";

export function PlanCard({ plan, isSelected, onClick }) {
  const { dispatch } = useFunnel();

  const handleClick = () => {
    // Track the event with Facebook Pixel
    trackFBEvent("InitiateCheckout", {
      content_category: "Subscription",
      content_name: plan.duration,
      currency: "USD",
      value: plan.discountedPrice,
    });

    // Save selected plan to context
    dispatch({
      type: "UPDATE_USER_DATA",
      field: "selectedPlan",
      value: plan,
    });

    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={`
        relative p-6 bg-white rounded-2xl border-2 transition-all duration-200
        ${
          isSelected
            ? "border-green-500 shadow-lg scale-105"
            : "border-gray-200 hover:border-green-300"
        }
      `}
      onClick={handleClick}
    >
      {plan.popular && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-green-500 text-white px-6 py-1.5 rounded-full text-sm font-bold shadow-md animate-bounce">
            BEST VALUE
          </span>
        </div>
      )}
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg text-gray-500 font-semibold">
            {plan.duration}
          </h3>
          <div className="flex items-baseline space-x-2">
            <span className="text-sm text-gray-400 line-through">
              ${plan.originalPrice}
            </span>
            <span
              className="text-xs
              text-gray-400"
            >
              ${plan.discountedPrice}
            </span>
          </div>
        </div>
        <div className="text-center">
          <div className="font-bold text-3xl text-gray-600">${plan.perDay}</div>
          <div className="text-sm text-gray-400">per day</div>
        </div>
      </div>
    </div>
  );
}
